module.exports = __webpack_public_path__ + "img/hire-a-helper.1d491fe0.svg";